module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.fee66e71.woff";